###
Common Modules
###

angular.module 'rjmNg.common.filters', []
angular.module 'rjmNg.common.services', [
  "rjmNg.common.api"
]
angular.module 'rjmNg.common.api', [
  'ngResource'
  'rjmetrics.model-factory'
  'angular-cache'
]
angular.module 'rjmNg.common.directives', [
  'rjmNg.common.api'
  'rjmNg.common.templates'
  'rjmNg.common.services'
]
angular.module 'rjmNg.common.tagSelector', []

###
CloudBI Modules
###

angular.module 'rjmNg.api', [
  'rjmNg.common.services'
  'rjmNg.common.api'
]

angular.module 'rjmNg.directives', [
  'ui'
  '$strap.directives'
  'gridster'
  'ngMd5'
  'moment-picker'
  'rjmNg.common.services'
  'rjmNg.common.tagSelector'
]

angular.module 'rjmNg.services', [
  'ngMd5'
  'rjmNg.api'
  'rjmNg.common.services'
]

angular.module 'rjmNg.filters', []

angular.module 'rjmNg.controllers', [
  "rjmNg.api"
  'rjmNg.common.services'
]

angular.module 'rjmNg.constants', []

angular.module 'rjmNg', [
  'ngSanitize'
  'ngRoute'
  'ngMessages'
  'ngRaven'
  'rjmNg.templates'
  'rjmNg.api'
  'rjmNg.common.api'
  'rjmNg.controllers'
  'rjmNg.common.services'
  'rjmNg.services'
  'rjmNg.common.directives'
  'rjmNg.common.filters'
  'rjmNg.directives'
  'rjmNg.filters'
  'rjmNg.constants'
]

angular.module("rjmNg").value("appParams", window.rjm.app.params)
angular.module("rjmNg").value("webhookUrl", window.rjm.app.params?.webhookUrl)
angular.module("rjmNg").value("dataImportUrl", window.rjm.app.params?.dataImportUrl)
angular.module("rjmNg").value("siteRoot", window.rjm.app.params?.siteRoot)
angular.module("rjmNg").value("adminRoot", window.rjm.app.params?.adminRoot)
angular.module("rjmNg").value("serviceRoot", window.rjm.app.params?.serviceRoot)

